module.exports = __webpack_public_path__ + "static/media/logo-nationwide.29f8921f.svg";